(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/start/start.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/start/start.js');
"use strict";

const WidgetArea = svs.ticket_partner.sharedComponents.widgetArea.WidgetArea;
const _React = React,
  Fragment = _React.Fragment;
const StartPage = () => React.createElement(Fragment, null, React.createElement(WidgetArea, {
  areaName: "startAreaWidget1",
  className: "full-width-widget",
  fallback: React.createElement("h1", null, "H\xE4r skulle det ha laddats in en bild")
}), React.createElement(WidgetArea, {
  areaName: "startAreaWidget2",
  className: "u-text-left widget-default-margin-top-0",
  fallback: React.createElement("h1", null, "H\xE4r skulle det ha laddats in en artikel")
}));
svs.ticket_partner.start.StartPage = StartPage;

 })(window);